import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/free-solid-svg-icons';

const ShareIcon = ({ icon, link }) => (
  <FontAwesomeIcon className="shareIcon fa-3x" icon={icon} />
);

export default ShareIcon;
